import { render, staticRenderFns } from "./consultRecords.vue?vue&type=template&id=18b30e53&scoped=true"
import script from "./consultRecords.vue?vue&type=script&lang=js"
export * from "./consultRecords.vue?vue&type=script&lang=js"
import style0 from "./consultRecords.vue?vue&type=style&index=0&id=18b30e53&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b30e53",
  null
  
)

export default component.exports